export function RadioBox({ name, options, value, onChange, children }) {
  return (
    <div className="question radio-box">
      {children ? <div className="question-title">{children}</div> : null}
      {options.map((option, i) => {
        const optionId = `${name}-${i}`;
        const isSelected = value === option.value;
        return (
          <div key={optionId}>
            <label className="radio-container" htmlFor={optionId}>
              <input
                type="radio"
                name={name}
                id={optionId}
                value={String(option.value)}
                checked={isSelected}
                onChange={() => onChange(option.value)}
              />
              <span className="checkmark" />
              <span className="label">{option.label}</span>
            </label>
          </div>
        );
      })}
    </div>
  );
}
